import { useMutation, useQuery } from '@tanstack/react-query'
import { instance } from '../instance'

export const useFetchProfile = (user_id: string) => {
  const fetchProfile = async () => {
    const { data } = await instance.get(`/admin-dashboard/get-admin/${user_id}`)
    return data
  }
  const queryProfile = useQuery({
    queryKey: ['fetch-profile', user_id],
    queryFn: fetchProfile,
  })
  return queryProfile
}

export const useUpdateProfile = () => {
  const updateProfileAPI = async (
    payload: UpdateProfilePayload,
  ): Promise<UpdateProfileResponse> => {
    const response = await instance.patch(
      `/admin-dashboard/update-admin/${payload.user_id}`,
      payload,
    )
    return response.data
  }
  const mutateAPI = useMutation({
    mutationFn: updateProfileAPI,
    mutationKey: ['update profile'],
  })
  return mutateAPI
}
